import React from 'react';
import { Box } from '@material-ui/core';
import {
  CapaQuotationServiceType,
  CapaQuotationPartnerPortfolioService,
  CapaQuotationPartnerPortfolio
} from '@generated/graphql';
import { CustomizedTypography } from '@components/Customized';
import { requestEnumToString } from '@utils/enumToString';
import DetailViewDialog from '../DetailViewDialog';
import ListItem from './ListItem';

const PortfolioDetailInformation: React.FunctionComponent<{
  portfolio: CapaQuotationPartnerPortfolio;
}> = ({ portfolio }) => {
  return (
    <DetailViewDialog.Informaiton
      projectName={portfolio.projectName}
      description={portfolio.description ?? undefined}
      content={
        <>
          <ListItem label="고객사" value={portfolio.client} />
          <ListItem
            label="가공방식"
            value={renderUsedTech(portfolio.capabilities ?? [])}
          />
          <ListItem
            label="수량"
            value={
              portfolio.quantity
                ? `${
                    portfolio.produceStep
                      ? `${requestEnumToString(portfolio.produceStep)}, `
                      : ''
                  }${portfolio.quantity.toLocaleString('kr')}개`
                : null
            }
          />
          <ListItem
            label="제품용도"
            value={requestEnumToString(portfolio.projectPurpose?.[0])}
            detail={portfolio.productType ?? undefined}
          />
        </>
      }
    />
  );
};

export default PortfolioDetailInformation;

const renderUsedTech = (usedTech?: CapaQuotationPartnerPortfolioService[]) => {
  if (!usedTech || usedTech?.length === 0) {
    return null;
  }
  return (
    <Box display={'flex'} flexDirection={'column'} gridGap={4}>
      {usedTech.map(({ service, detailedServices }) => {
        return (
          <Box key={service}>
            <CustomizedTypography variant="body2" fontWeight="500">
              {requestEnumToString(service as CapaQuotationServiceType)}
            </CustomizedTypography>
            {detailedServices && (
              <CustomizedTypography
                variant={'subtitle2'}
                color={'textSecondary'}
              >
                {detailedServices
                  .map((detailedService) =>
                    requestEnumToString(detailedService).replace(/ \(.*?\)/, '')
                  )
                  .join(', ')}
              </CustomizedTypography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};
